const DetailPanel = () => {
  return <p>contact detail panel </p>
}

export default DetailPanel
